export default __webpack_public_path__ + "static/media/ic-arrow-next.0a8779c1.svg";